











































































import { Component, Vue } from "vue-property-decorator";
@Component({
  components: {},
})
export default class Home extends Vue {
  public active = 0;

  public mounted() {
    if (this.$route.query.type === "contact") {
      (document as any)
        .getElementById("contact_us")
        .scrollIntoView({ behavior: "smooth" });
    }
  }
}
